<script setup lang="ts"></script>

<template>
  <div class="w-full overflow-x-auto">
    <table class="w-full border-spacing-0">
      <tbody class="divide-y divide-gray-100">
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>
